import { gql } from "lib/apolloClient";

export const publishedDataFragments = {
  plannerElementNodeFragment: gql`
    fragment plannerElementNodeItem on PlannerElementNode {
      id
      displaySequence
      uid
      label
      subText
      gradingType
      code
      depth
      # written to make consistent with unitPlanFragment
      parent
      type
      subType
      updatedAt
      children
      lockingInfo(filters: $lockingInfoFilters) @skip(if: $skipLockingInfo) {
        isLocked
      }
      dataSetNodeWrapper {
        plannerElementNodeSet {
          id
          title
        }
        properties {
          isArchived
          isPowerStandard
          weight
          subjects {
            id
            name
            # written to make consistent with unitPlanFragment
            isArchived
          }
          grades {
            id
            name
          }
          tags {
            id
            label
          }
          subjectGroups {
            id
            name
          }
          # written to make consistent with unitPlanFragment
          associatedPlannerElementNodes {
            id
          }
        }
      }
    }
  `,
  plannerBenchmarkFragment: gql`
    fragment plannerBenchmarkItem on PlannerBenchmark {
      id
      displaySequence
      uid
      label
      subText
      gradingType
      code
      depth
      children
      parent
      updatedAt
      subject
      lockingInfo(filters: $lockingInfoFilters) @skip(if: $skipLockingInfo) {
        isLocked
      }
      dataSetNodeWrapper {
        standardSet {
          id
          title
        }
        properties {
          isArchived
          isPowerStandard
          weight
          grades {
            id
            name
          }
          tags {
            id
            label
          }
          subject {
            id
            name
            # written to make consistent with unitPlanFragment
            isArchived
          }
        }
      }
    }
  `,
  plannerAtlFragment: gql`
    fragment plannerATLItem on PlannerATL {
      id
      uid
      label
      parent
      levelId
      levels {
        id
        value
      }
      children
      depth
      isLeaf
      displaySequence
      atlCategory {
        id
      }
      subText
      dataSetNodeWrapper {
        properties {
          isArchived
          grades {
            id
            name
          }
        }
      }
    }
  `,
  plannerElementRootNodeFragment: gql`
    fragment plannerElementRootNodeItem on PlannerElementNode {
      id
      label
    }
  `,
  plannerBenchmarkRootFragment: gql`
    fragment plannerBenchmarkRootItem on PlannerBenchmark {
      id
      label
    }
  `,
  plannerATLRootFragment: gql`
    fragment plannerATLRootItem on PlannerATL {
      id
      label
    }
  `,
};

export const dataSetNodeCountWrapperFragment = gql`
  fragment dataSetNodeCountWrapperFragment on PlannerElementNode {
    id
    dataSetNodeCountWrapper(filters: $nodeCountFilters) {
      assessment @skip(if: $shouldSkipAssessment) {
        totalCount
        directCount @include(if: $isParentTaggingEnabled)
      }
      portfolio @skip(if: $shouldSkipPortfolio) {
        totalCount
        directCount @include(if: $isParentTaggingEnabled)
      }
      unitPlan @skip(if: $shouldSkipUnitPlan) {
        totalCount
        directCount @include(if: $isParentTaggingEnabled)
      }
    }
  }
`;

export const dataSetNodeCountWrapperFragmentPyp = gql`
  fragment dataSetNodeCountWrapperFragmentPyp on PlannerBenchmark {
    id
    dataSetNodeCountWrapper(filters: $nodeCountFilters) {
      assessment @skip(if: $shouldSkipAssessment) {
        totalCount
        directCount @include(if: $isParentTaggingEnabled)
      }
      portfolio @skip(if: $shouldSkipPortfolio) {
        totalCount
        directCount @include(if: $isParentTaggingEnabled)
      }
      unitPlan @skip(if: $shouldSkipUnitPlan) {
        totalCount
        directCount @include(if: $isParentTaggingEnabled)
      }
    }
  }
`;
